import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import {
	plannedMaintenanceTemplatesRestCrudThunksForBuyer,
	plannedMaintenanceTemplatesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_templates_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import PMTemplateDetailCard from './PMTemplateDetailCard';
import './PlannedMaintenanceTemplatesDetailDetailsPage.less';

const { Content } = Layout;

class PlannedMaintenanceTemplatesDetailPage extends React.Component<any, any> {
	componentDidMount() {
		const { getPlannedMaintenanceTemplate, match } = this.props;
		const plannedMaintenanceTemplateId = match.params.id;
		getPlannedMaintenanceTemplate(plannedMaintenanceTemplateId);
	}

	render() {
		const { plannedMaintenanceTemplate, plannedMaintenanceTemplatesFetching, userType } =
			this.props;

		return plannedMaintenanceTemplatesFetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="plannedMaintenanceTemplatesDetailDetailsPage">
				<PMTemplateDetailCard plannedMaintenanceTemplate={plannedMaintenanceTemplate} />
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	plannedMaintenanceTemplatesFetching: state.planned_maintenance_templates.fetching,
	plannedMaintenanceTemplate: state.planned_maintenance_templates.detail,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getPlannedMaintenanceTemplate: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceTemplatesRestCrudThunksForSupplier.readOne(id)
				: plannedMaintenanceTemplatesRestCrudThunksForBuyer.readOne(id)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PlannedMaintenanceTemplatesDetailPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
